import {
  removeCalendarSync as _removeCalendarSync,
  RemoveCalendarSyncOptions,
} from '@griply/services';
import {
  arrayRemove,
  deleteField,
  doc,
  getFirestore,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

export type RemoveCalendarSyncInput = Pick<
  RemoveCalendarSyncOptions,
  'connectionId' | 'linkedItemId'
>;

export const removeCalendarSync = (input: RemoveCalendarSyncInput): void =>
  _removeCalendarSync({
    ...input,
    doc,
    updateDoc,
    db: getFirestore(),
    serverTimestamp,
    deleteField,
    arrayRemove,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.RemoveCalendarSync,
        error,
        docPath: `external-connections/${input.connectionId}`,
      }),
  });
